/* Neeta Lulla — collection page behaviour.

   Works with sections/nl-collection-grid.liquid. Filtering, sorting and "Load More" all use
   Shopify's Section Rendering API (?section_id=…): the server renders the real, filtered
   markup and this script swaps the pieces into the page — so counts, badges, prices and
   filter values always come from Shopify, never from the browser.

   Every feature degrades gracefully: without JS the sidebar is a normal GET form and
   "Load More" is a normal link to the next page. */
(function () {
  'use strict';
  if (window.__nlCollectionLoaded) return;
  window.__nlCollectionLoaded = true;

  var KEY_FILTERS = 'nlcFiltersOpen';
  var KEY_WISH = 'nlcWishlist';

  /* ---------- tiny helpers ---------- */
  function qs(scope, sel) { return scope.querySelector(sel); }
  function qsa(scope, sel) { return Array.prototype.slice.call(scope.querySelectorAll(sel)); }
  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }
  function formatIN(n) {
    try { return Number(n).toLocaleString('en-IN'); } catch (e) { return String(n); }
  }
  function parseNum(v) {
    var d = String(v).replace(/[^\d]/g, '');
    return d ? parseInt(d, 10) : NaN;
  }
  function store(kind, key, val) {
    try {
      var st = kind === 's' ? window.sessionStorage : window.localStorage;
      if (val === undefined) return st.getItem(key);
      st.setItem(key, val);
    } catch (e) { /* storage blocked — ignore */ }
    return null;
  }
  function newController() { return ('AbortController' in window) ? new AbortController() : null; }

  function init(root) {
    if (root.getAttribute('data-nl-init')) return;
    root.setAttribute('data-nl-init', '1');

    var sectionId = root.getAttribute('data-section-id');
    var baseUrl = root.getAttribute('data-collection-url') || window.location.pathname;
    var defaultSort = root.getAttribute('data-default-sort') || '';

    var layout = qs(root, '[data-nl-layout]');
    var toggle = qs(root, '[data-nl-filter-toggle]');
    var toggleLabel = qs(root, '[data-nl-filter-label]');
    var sortSelect = qs(root, '[data-nl-sort]');
    var drawer = qs(root, '[data-nl-drawer]');
    var applyBtn = qs(root, '[data-nl-apply]');

    var mainCtrl = null;
    var previewCtrl = null;
    var lastFocus = null;
    // Bumped on every filter edit and every request. A response is only swapped in if nothing
    // newer happened since it was requested — so a slow reply can never wipe a fresher tick.
    var seq = 0;

    /* ---------- sticky toolbar sits directly under the (sticky) site header ---------- */
    function setHeaderVar() {
      var h = document.querySelector('header.main-header');
      var v = h ? Math.round(h.getBoundingClientRect().height) : 117;
      root.style.setProperty('--nlc-header-h', v + 'px');
    }
    setHeaderVar();
    window.addEventListener('resize', debounce(setHeaderVar, 150));
    window.addEventListener('load', setHeaderVar);

    /* ---------- accordion ---------- */
    function setAcc(item, open) {
      var panel = qs(item, '.nlc-acc-panel');
      var head = qs(item, '.nlc-acc-head');
      if (!panel) return;
      item.classList.toggle('open', open);
      panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
      if (head) head.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    function refreshAccordions(scope) {
      qsa(scope || root, '.nlc-acc-item.open').forEach(function (i) { setAcc(i, true); });
    }

    /* ---------- show / hide the filter sidebar ---------- */
    function setFiltersOpen(open, persist) {
      if (!layout) return;
      layout.classList.toggle('filters-open', open);
      if (toggle) {
        toggle.classList.toggle('active', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      if (toggleLabel) toggleLabel.textContent = open ? 'Hide Filter' : 'Show Filter';
      if (persist) store('s', KEY_FILTERS, open ? '1' : '0');
      if (open) window.requestAnimationFrame(function () { refreshAccordions(); });
    }
    (function () {
      var saved = store('s', KEY_FILTERS);
      var open = saved === null ? root.getAttribute('data-filters-open-default') === 'true' : saved === '1';
      setFiltersOpen(open, false);
    })();

    /* ---------- price slider ---------- */
    function priceParts(pr) {
      return {
        min: parseFloat(pr.getAttribute('data-min')),
        max: parseFloat(pr.getAttribute('data-max')),
        tMin: qs(pr, '[data-nl-price-min]'), tMax: qs(pr, '[data-nl-price-max]'),
        rMin: qs(pr, '[data-nl-range-min]'), rMax: qs(pr, '[data-nl-range-max]'),
        hMin: qs(pr, '[data-nl-price-hidden-min]'), hMax: qs(pr, '[data-nl-price-hidden-max]'),
        fill: qs(pr, '.nlc-slider-fill')
      };
    }
    function paintPrice(pr, lo, hi) {
      var p = priceParts(pr);
      lo = Math.max(p.min, Math.min(lo, p.max));
      hi = Math.max(p.min, Math.min(hi, p.max));
      if (lo > hi) { var tmp = lo; lo = hi; hi = tmp; }
      p.rMin.value = lo; p.rMax.value = hi;
      p.tMin.value = formatIN(lo); p.tMax.value = formatIN(hi);
      var span = (p.max - p.min) || 1;
      p.fill.style.left = ((lo - p.min) / span * 100) + '%';
      p.fill.style.right = (100 - (hi - p.min) / span * 100) + '%';
      // an unchanged end of the range means "no limit" — keep it out of the URL
      p.hMin.value = lo > p.min ? lo : '';
      p.hMax.value = hi < p.max ? hi : '';
      // when both thumbs pile up at the top end, keep the lower one grabbable
      p.rMin.style.zIndex = lo > p.min + span / 2 ? 4 : 2;
      p.rMax.style.zIndex = 3;
    }
    function initPrices() {
      qsa(root, '[data-nl-price]').forEach(function (pr) {
        var p = priceParts(pr);
        paintPrice(pr, parseFloat(p.rMin.value), parseFloat(p.rMax.value));
      });
    }
    function priceFromRange(target) {
      var pr = target.closest('[data-nl-price]');
      var p = priceParts(pr);
      var lo = parseFloat(p.rMin.value), hi = parseFloat(p.rMax.value);
      if (target === p.rMin) lo = Math.min(lo, hi); else hi = Math.max(hi, lo);
      paintPrice(pr, lo, hi);
    }
    function priceFromText(target) {
      var pr = target.closest('[data-nl-price]');
      var p = priceParts(pr);
      var lo = parseNum(p.tMin.value), hi = parseNum(p.tMax.value);
      if (isNaN(lo)) lo = parseFloat(p.rMin.value);
      if (isNaN(hi)) hi = parseFloat(p.rMax.value);
      paintPrice(pr, lo, hi);
    }

    /* ---------- build a URL from the current filter state ---------- */
    function collect(scope) {
      var params = new URLSearchParams();
      if (!scope) return params;
      qsa(scope, 'input[type="checkbox"][data-nl-filter-input]').forEach(function (cb) {
        if (cb.checked && !cb.disabled) params.append(cb.name, cb.value);
      });
      qsa(scope, '[data-nl-price]').forEach(function (pr) {
        var p = priceParts(pr);
        if (p.hMin.value !== '') params.append(p.hMin.name, p.hMin.value);
        if (p.hMax.value !== '') params.append(p.hMax.name, p.hMax.value);
      });
      return params;
    }
    function buildUrl(params, sort) {
      if (sort && sort !== defaultSort) params.set('sort_by', sort);
      var q = params.toString();
      return baseUrl + (q ? '?' + q : '');
    }
    function desktopFilters() { return qs(root, '[data-nl-filters="desktop"]'); }
    function drawerFilters() { return qs(root, '[data-nl-filters="drawer"]'); }
    function currentSort() { return sortSelect ? sortSelect.value : (root.getAttribute('data-sort') || defaultSort); }
    function drawerSort() {
      var r = qs(root, '[data-nl-sort-radio]:checked');
      return r ? r.value : currentSort();
    }

    /* ---------- Section Rendering API ---------- */
    function fetchSection(url, ctrl) {
      var u = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);
      var opts = { credentials: 'same-origin' };
      if (ctrl) opts.signal = ctrl.signal;
      return fetch(u, opts)
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
    }
    function newRoot(doc) { return doc.querySelector('[data-nl-collection]'); }

    function replaceNode(sel, from) {
      var cur = qs(root, sel), nw = qs(from, sel);
      if (cur && nw) cur.replaceWith(document.importNode(nw, true));
    }

    function captureAccState() {
      var st = {};
      qsa(root, '[data-nl-filters]').forEach(function (c) {
        st[c.getAttribute('data-nl-filters')] = {
          open: qsa(c, '.nlc-acc-item.open').map(function (g) { return g.getAttribute('data-group'); }),
          more: qsa(c, '[data-nl-more-grid]:not([hidden])').map(function (g) { return g.closest('.nlc-acc-item').getAttribute('data-group'); })
        };
      });
      return st;
    }
    function setMore(item, expanded) {
      var grid = qs(item, '[data-nl-more-grid]'), btn = qs(item, '[data-nl-showmore]');
      if (!grid || !btn) return;
      grid.hidden = !expanded;
      btn.textContent = expanded ? '– Show Less' : '+ Show More';
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }
    function restoreAccState(st) {
      qsa(root, '[data-nl-filters]').forEach(function (c) {
        var s = st[c.getAttribute('data-nl-filters')];
        if (!s) return;
        qsa(c, '.nlc-acc-item').forEach(function (item) {
          var g = item.getAttribute('data-group');
          var grid = qs(item, '[data-nl-more-grid]');
          if (grid && (s.more.indexOf(g) > -1 || !grid.hidden)) setMore(item, true);
          setAcc(item, s.open.indexOf(g) > -1);
        });
      });
    }

    function swapIn(next) {
      var acc = captureAccState();

      var wrap = qs(root, '[data-nl-grid-wrap]'), nwrap = qs(next, '[data-nl-grid-wrap]');
      if (wrap && nwrap) {
        wrap.innerHTML = '';
        Array.prototype.forEach.call(nwrap.childNodes, function (n) { wrap.appendChild(document.importNode(n, true)); });
      }
      replaceNode('[data-nl-more]', next);
      replaceNode('[data-nl-count]', next);

      ['desktop', 'drawer'].forEach(function (ctx) {
        var cur = qs(root, '[data-nl-filters="' + ctx + '"]'), nw = qs(next, '[data-nl-filters="' + ctx + '"]');
        if (cur && nw) {
          cur.innerHTML = '';
          Array.prototype.forEach.call(nw.childNodes, function (n) { cur.appendChild(document.importNode(n, true)); });
        }
      });

      var ac = qs(root, '[data-nl-active-count]'), nac = qs(next, '[data-nl-active-count]');
      if (ac && nac) { ac.textContent = nac.textContent; ac.hidden = nac.hidden; }

      var total = next.getAttribute('data-total');
      var sort = next.getAttribute('data-sort');
      root.setAttribute('data-total', total);
      root.setAttribute('data-sort', sort);
      if (sortSelect) sortSelect.value = sort;
      qsa(root, '[data-nl-sort-radio]').forEach(function (r) { r.checked = (r.value === sort); });
      if (applyBtn) applyBtn.textContent = applyLabel(total);

      restoreAccState(acc);
      initPrices();
      syncWishlist();
      observeCards();
    }

    function applyLabel(total) {
      var n = parseInt(total, 10) || 0;
      return 'Show ' + n + (n === 1 ? ' Result' : ' Results');
    }

    function scrollToResults() {
      var h = parseInt(getComputedStyle(root).getPropertyValue('--nlc-header-h'), 10) || 0;
      var top = root.getBoundingClientRect().top + window.pageYOffset - h;
      if (window.pageYOffset > top + 60) window.scrollTo({ top: top, behavior: 'smooth' });
    }

    function loadResults(url, push) {
      var wrap = qs(root, '[data-nl-grid-wrap]');
      if (mainCtrl) mainCtrl.abort();
      var ctrl = mainCtrl = newController();
      var mySeq = ++seq;
      if (wrap) wrap.classList.add('is-loading');
      return fetchSection(url, ctrl).then(function (doc) {
        if (mySeq !== seq) return; // superseded by a newer edit/request — its own response will win
        var next = newRoot(doc);
        if (!next) throw new Error('Section missing from response');
        swapIn(next);
        if (push) window.history.pushState({ nlc: 1 }, '', url);
        scrollToResults();
      }).catch(function (err) {
        if (err && err.name === 'AbortError') return;
        window.location.href = url; // anything unexpected: fall back to a normal page load
      }).then(function () {
        if (mySeq === seq) {
          var w = qs(root, '[data-nl-grid-wrap]');
          if (w) w.classList.remove('is-loading');
        }
      });
    }

    var applyDesktop = debounce(function () {
      loadResults(buildUrl(collect(desktopFilters()), currentSort()), true);
    }, 220);

    function applyFromDrawer() {
      loadResults(buildUrl(collect(drawerFilters()), drawerSort()), true);
      closeDrawer(true);
    }

    /* live "Show N Results" count while the drawer's choices are still being staged */
    var previewDrawer = debounce(function () {
      if (!applyBtn) return;
      var url = buildUrl(collect(drawerFilters()), drawerSort());
      if (previewCtrl) previewCtrl.abort();
      var ctrl = previewCtrl = newController();
      fetchSection(url, ctrl).then(function (doc) {
        var next = newRoot(doc);
        if (next) applyBtn.textContent = applyLabel(next.getAttribute('data-total'));
      }).catch(function () { /* keep the old label */ });
    }, 300);

    /* ---------- mobile drawer ---------- */
    function openDrawer(mode) {
      if (!drawer) return;
      lastFocus = document.activeElement;
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (mode === 'sort') {
        var s = qs(drawer, '.nlc-acc-item[data-group="sort"]');
        if (s) setAcc(s, true);
      }
      refreshAccordions(drawer);
      var panel = qs(drawer, '.nlc-drawer');
      if (panel) panel.focus();
    }
    function resetDrawer() {
      // discard staged, un-applied choices (the server-rendered state is each input's default)
      qsa(drawer, 'input[type="checkbox"], input[type="radio"]').forEach(function (i) { i.checked = i.defaultChecked; });
      qsa(drawer, '[data-nl-price]').forEach(function (pr) {
        var p = priceParts(pr);
        paintPrice(pr, parseFloat(p.rMin.defaultValue), parseFloat(p.rMax.defaultValue));
      });
      if (applyBtn) applyBtn.textContent = applyLabel(root.getAttribute('data-total'));
    }
    function closeDrawer(applied) {
      if (!drawer || !drawer.classList.contains('open')) return;
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (!applied) resetDrawer();
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function clearDrawer() {
      qsa(drawer, 'input[type="checkbox"]').forEach(function (cb) { cb.checked = false; });
      qsa(drawer, '[data-nl-price]').forEach(function (pr) {
        var p = priceParts(pr);
        paintPrice(pr, p.min, p.max);
      });
      previewDrawer();
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer && drawer.classList.contains('open')) closeDrawer(false);
    });

    /* ---------- wishlist hearts (saved in this browser) ---------- */
    function getWish() {
      try { return JSON.parse(store('l', KEY_WISH) || '[]'); } catch (e) { return []; }
    }
    function syncWishlist() {
      var w = getWish();
      qsa(root, '[data-nl-wish]').forEach(function (b) {
        var on = w.indexOf(b.getAttribute('data-nl-wish')) > -1;
        b.classList.toggle('active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    function toggleWish(btn) {
      var h = btn.getAttribute('data-nl-wish'), w = getWish(), i = w.indexOf(h);
      if (i > -1) w.splice(i, 1); else w.push(h);
      store('l', KEY_WISH, JSON.stringify(w));
      syncWishlist();
    }

    /* ---------- quick add ---------- */
    function quickAdd(btn) {
      if (btn.disabled) return;
      var id = parseInt(btn.getAttribute('data-nl-quickadd'), 10);
      if (!id) return;
      var original = btn.textContent;
      var reset = function () { setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1800); };
      btn.disabled = true;
      btn.textContent = 'Adding…';
      var addUrl = (window.theme && window.theme.routes && window.theme.routes.cartAdd) || '/cart/add.js';
      fetch(addUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Unavailable'); });
        return r.json();
      }).then(function () {
        return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } });
      }).then(function (r) { return r.json(); }).then(function (cart) {
        qsa(document, '.bag-count').forEach(function (el) { el.textContent = cart.item_count; });
        btn.textContent = 'Added to Bag ✓';
        reset();
      }).catch(function (err) {
        var msg = (err && err.message) || '';
        btn.textContent = msg && msg.length < 30 ? msg : 'Unavailable';
        reset();
      });
    }

    /* ---------- load more ---------- */
    function loadMore(a) {
      if (a.classList.contains('is-loading')) return;
      var href = a.getAttribute('href');
      if (!href) return;
      a.classList.add('is-loading');
      fetchSection(href, null).then(function (doc) {
        var next = newRoot(doc);
        var grid = qs(root, '[data-nl-grid]'), ngrid = next && qs(next, '[data-nl-grid]');
        if (!grid || !ngrid) throw new Error('Grid missing');
        var added = [];
        qsa(ngrid, '.nlc-card').forEach(function (card) {
          var n = document.importNode(card, true);
          grid.appendChild(n);
          added.push(n);
        });
        replaceNode('[data-nl-more]', next);
        replaceNode('[data-nl-count]', next);
        syncWishlist();
        observeCards();
        var first = added[0] && qs(added[0], '.nlc-card-info');
        if (first) first.focus({ preventScroll: true });
      }).catch(function () { window.location.href = href; });
    }

    /* ---------- cards fade in as they scroll into view ---------- */
    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    function observeCards() {
      var cards = qsa(root, '.nlc-card:not(.in)');
      if (!io) { cards.forEach(function (c) { c.classList.add('in'); }); return; }
      root.classList.add('nlc-reveal-ready');
      cards.forEach(function (c) { io.observe(c); });
    }

    /* ---------- events (delegated, so swapped-in markup keeps working) ---------- */
    root.addEventListener('click', function (e) {
      var t = e.target;
      var el;

      if ((el = t.closest('[data-nl-filter-toggle]'))) {
        setFiltersOpen(!layout.classList.contains('filters-open'), true);
        return;
      }

      if ((el = t.closest('.nlc-acc-head'))) {
        var item = el.closest('.nlc-acc-item');
        var box = item.closest('[data-accordion]');
        var willOpen = !item.classList.contains('open');
        if (box && box.getAttribute('data-accordion') === 'single') {
          qsa(box, '.nlc-acc-item').forEach(function (i) { if (i !== item) setAcc(i, false); });
        }
        setAcc(item, willOpen);
        return;
      }

      if ((el = t.closest('[data-nl-showmore]'))) {
        var it = el.closest('.nlc-acc-item');
        var grid = qs(it, '[data-nl-more-grid]');
        setMore(it, grid ? grid.hidden : false);
        setAcc(it, true); // re-measure the panel
        return;
      }

      if ((el = t.closest('[data-nl-view]'))) {
        qsa(root, '[data-nl-view]').forEach(function (b) {
          var on = b === el;
          b.classList.toggle('active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (layout) layout.classList.toggle('is-dense', el.getAttribute('data-nl-view') === '6');
        return;
      }

      if ((el = t.closest('[data-nl-clear]'))) {
        e.preventDefault();
        if (el.closest('[data-nl-drawer]')) clearDrawer();
        else loadResults(buildUrl(new URLSearchParams(), currentSort()), true);
        return;
      }

      if ((el = t.closest('[data-nl-apply]'))) { applyFromDrawer(); return; }

      if ((el = t.closest('[data-nl-drawer-open]'))) { openDrawer(el.getAttribute('data-nl-drawer-open')); return; }
      if (t.closest('[data-nl-drawer-close]') || t === drawer) { closeDrawer(false); return; }

      if ((el = t.closest('[data-nl-wish]'))) { e.preventDefault(); toggleWish(el); return; }
      if ((el = t.closest('[data-nl-quickadd]'))) { e.preventDefault(); quickAdd(el); return; }
      if ((el = t.closest('[data-nl-more-btn]'))) { e.preventDefault(); loadMore(el); return; }
    });

    root.addEventListener('input', function (e) {
      var t = e.target;
      if (t.matches('[data-nl-range-min], [data-nl-range-max]')) priceFromRange(t);
    });

    root.addEventListener('change', function (e) {
      var t = e.target;
      var inDrawer = !!t.closest('[data-nl-drawer]');

      if (t.matches('[data-nl-sort]')) {
        loadResults(buildUrl(collect(desktopFilters()), t.value), true);
        return;
      }
      if (t.matches('[data-nl-sort-radio]')) { previewDrawer(); return; }

      if (t.matches('[data-nl-range-min], [data-nl-range-max]')) priceFromRange(t);
      else if (t.matches('[data-nl-price-min], [data-nl-price-max]')) priceFromText(t);
      else if (!t.matches('[data-nl-filter-input]')) return;

      if (inDrawer) { previewDrawer(); } else { seq++; applyDesktop(); }
    });

    // pressing Enter inside a price box applies it (instead of submitting the form natively)
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var t = e.target;
      if (t.matches && t.matches('[data-nl-price-min], [data-nl-price-max]')) {
        e.preventDefault();
        priceFromText(t);
        if (t.closest('[data-nl-drawer]')) { previewDrawer(); } else { seq++; applyDesktop(); }
      }
    });

    var form = qs(root, '[data-nl-filter-form]');
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); applyDesktop(); });

    window.addEventListener('popstate', function (e) {
      if (e.state && e.state.nlc) loadResults(window.location.pathname + window.location.search, false);
    });
    window.history.replaceState({ nlc: 1 }, '', window.location.href);

    /* ---------- first paint ---------- */
    refreshAccordions();
    initPrices();
    syncWishlist();
    observeCards();
    window.addEventListener('load', function () { refreshAccordions(); });
    window.addEventListener('resize', debounce(function () { refreshAccordions(); }, 150));
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { refreshAccordions(); });
  }

  function initAll() { qsa(document, '[data-nl-collection]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll); // theme editor re-renders
})();